
 export class Role {
    constructor(
          public id?: number,
          public name?: string,
          public description?: string,
          public recordVersion?: number,
      ) {
      }
  }
 
 





// WEBPACK FOOTER //
// ./src/app/shared/model/role.model.ts